import { Button, Card, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useState } from 'react';

const AdminCreateAuthorComponent = ({ setLoading, onCreate }) => {
  const { database, videoDataStorage, currentUser } = useFirebase();

  const [newAuthor, setNewAuthor] = useState<{ name: string; photo: File }>({ name: '', photo: null });

  return (
    <Card bg={'dark'} style={{ gridArea: 'span 1 / span 2' }}>
      <Card.Header>
        <Card.Title className={'mb-0'}>
          <InputGroup>
            <Form.Control
              placeholder={'Crea nuovo autore...'}
              value={newAuthor.name}
              onChange={(e) => setNewAuthor((current) => ({ ...current, name: e.target.value.trim() }))}
            />
            <InputGroup.Append>
              <Button
                variant={'primary'}
                disabled={!(newAuthor.name && newAuthor.photo)}
                onClick={async () => {
                  setLoading(true);
                  try {
                    const { id } = await database.collection('authors').add({ name: newAuthor.name, lastEditBy: currentUser.uid, orderInList: 1_000_000 });
                    const storageRef = videoDataStorage.child(`authors_data/${id}/avatar.png`);
                    await storageRef.put(newAuthor.photo, { customMetadata: { uid: currentUser.uid } });
                    setNewAuthor({ name: '', photo: null });
                    onCreate();
                  } catch (error) {
                    console.error(error);
                    setLoading(false);
                  }
                }}
              >
                <FontAwesomeIcon icon={faSave} />
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group>
          <Form.Label>
            Avatar * <small className={'text-muted'}>(PNG)</small>
          </Form.Label>
          <Form.File accept={'image/png'} onChange={(e) => setNewAuthor((current) => ({ ...current, photo: e.target.files[0] }))} />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export { AdminCreateAuthorComponent as AdminCreateAuthor };
